<template>
   <el-dialog title="合作商发卡" :visible.sync="sendShow" width="30%">
      <el-form ref="form" label-width="100px">
       <el-form-item label="设备类型" required>
          <el-select v-model="form.device_code" placeholder="请选择">
            <el-option
              v-for="item in deviceCode"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div >
          <el-form-item label="发放用户" required>
            <el-upload
              action=""
              :on-change="beforeUpload"
              :file-list="fileList"
              :auto-upload="false"
              :show-file-list="true"
              accept=".xls, .xlsx"
              list-type="text"
              :limit="1"
              ref="upload"
            >
              <el-button type="success" size="small">导入表格</el-button>
              <el-button
                type="text"
                @click.stop="loadTemplate"
                style="margin: 10px"
                >下载模板</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.descr"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-left: 30px" @click="sendShow = false"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px"
          type="primary"
          :loading="loading"
          @click="importMemberExcel"
          >确认</el-button
        >
      </span>
    </el-dialog>
</template>

<script>
import { deviceCode } from "@/views/deviceManage/components/dict";
import XLSX from "xlsx";
export default {
  data() {
    return {
      deviceCode,
      sendShow: false,
      fileData: "",
      loading: false,
      fileList: [],
      form:{},
      plan:{},
      manager: JSON.parse(localStorage.getItem("managerInfo"))
    };
  },

  mounted() {
   
  },

  methods: {
    open(row){
        this.plan = row
        this.sendShow = true
    },
    loadTemplate() {
      let Header = [["序列号"]];
      let exportArr = [
        [],
      ];

      const headerWs = XLSX.utils.aoa_to_sheet(Header);
      const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {
        skipHeader: true,
        origin: "A2",
      });
      ws["!cols"] = [
        {
          wpx: 100,
        }
      ];
      /* 新建空的工作表 */
      const wb = XLSX.utils.book_new();

      // 可以自定义下载之后的sheetname
      XLSX.utils.book_append_sheet(wb, ws, "sheetName");

      /* 生成xlsx文件 */
      XLSX.writeFile(wb, "设备导入模板.xlsx");
      this.$message("导出成功，请前往下载列表查看");
    },
    upLoad(file) {
      console.log(file);
    },
    importMemberExcel() {
      if (!this.fileData) {
        this.$message("请选择要导入的数据");
        return;
      }
      if (!this.form.device_code) {
        this.$message("请选择类型");
        return;
      }
      if (!this.form.descr) {
        this.$message("请输入说明");
        return;
      }
      let formDate = new FormData();
      formDate.append("file", this.fileData);
      formDate.append("plan_id", this.plan.id);
      formDate.append("handler_id",this.manager.id);
      formDate.append("handler_name",this.manager.name);
      formDate.append("device_code", this.form.device_code);
      formDate.append("descr", this.form.descr);
      formDate.append("coop_id", this.$route.query.cid);
      this.loading = true;
      this.$axios({
        url: "/user/deviceInvestPlan/exportD",
        data: formDate,
        method: "post",
        processData: false,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          this.$message({ message: res.data.data });
          this.sendShow = false;
          this.loading = false;
          this.fileList = [];
        })
        .catch((err) => {
          this.loading = false;
        });
    },
   
    openSend() {
      this.sendShow = true;
    },
    // 文件选择回调
    beforeUpload(file) {
      this.fileData = file.raw;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log(ws);
        } catch (e) {
          return false;
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>

</style>